var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-1",attrs:{"no-gutters":""}},_vm._l((_vm.forgeList),function(item){return _c('v-col',{key:item,attrs:{"cols":"12","sm":"6"}},[_c('forge-item',{staticClass:"ma-1",attrs:{"name":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }